import { render, staticRenderFns } from "./DepositPoint.vue?vue&type=template&id=bde408e4&scoped=true"
import script from "./DepositPoint.vue?vue&type=script&lang=js"
export * from "./DepositPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde408e4",
  null
  
)

export default component.exports